import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_wor from '../../../axios-instance-wor';

/**
 * Obtener Trabajadores.
 */
export async function fetchWorkers({state, commit,}, reset_page = false) {

    commit('dashboard/load', true, {root: true});

    if (reset_page) {
        commit('resetPageParams');
    }

    await $http_wor.get('workers/' + state.params.company_id, {params: state.params})
        .then(async (response) => {
            commit('setWorkers', response.data.data);
            commit('dashboard/load', false, {root: true});

        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener un Trabajador.
 */
export async function getWorker({state, commit}, {id, company_id}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('workers/' + company_id + '/' + id,)
        .then(async (response) => {

            commit('setWorker', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear un Trabajador.
 */
export async function addWorker({state, commit, dispatch}, company_id) {
    return new Promise(async (resolve, reject) => {

        commit('dashboard/load', true, {root: true});

        await $http_wor.post('workers/' + company_id, state.worker)
            .then(async (response) => {

                await dispatch('fetchWorkerPositions', {id: state.worker.id, company_id});

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Actualizar un trabajador.
 */
export async function updateWorker({state, commit, dispatch}, company_id) {

    commit('dashboard/load', true, {root: true});


    await $http_wor.put('workers/' + company_id + '/' + state.worker.id, state.worker)

        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Eliminar un trabajador.
 */
export async function deleteWorker({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar el Trabajador?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, eliminar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http_wor.delete('workers/' + state.params.company_id + '/' + id)
                .then(async (response) => {
                    await dispatch('fetchWorkers');
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });


                }).catch((error) => {

                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

/**
 * Obtener empresas.
 */
export async function fetchCompanies({commit, state, rootState}, filter) {

    if (!rootState.dashboard.loading && filter && filter.length > 2) {
        commit('dashboard/load', true, {root: true});

        let params = {
            nombre: filter
        };

        await $http.get('/empresas/lista', {params})
            .then((response) => {
                commit('setCompanies', response.data.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}


/**
 * Obtener áreas.
 */
export async function fetchAreas({state, commit}, company_id) {
    commit('dashboard/load', true, {root: true});

    await $http_wor.get('areas/' + company_id, {params: {paginate: 0}})
        .then(async (response) => {
            commit('setAreas', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Cargos.
 */
export async function fetchPositions({state, commit}, company_id) {
    commit('dashboard/load', true, {root: true});
    await $http_wor.get('positions/' + company_id)
        .then(async (response) => {
            commit('setPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Cargos.
 */
export async function fetchPositionsWorkers({state, commit}, company_id) {
    commit('dashboard/load', true, {root: true});
    await $http_wor.get('worker/positions/' + company_id)
        .then(async (response) => {
            commit('setPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener tipos de Identificación.
 */
export async function fetchTypes({commit, state, rootState}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('/lists/TIID1')
        .then((response) => {

            commit('setTypes', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener tipos de Epp.
 */
export async function fetchTypesEpp({commit, state, rootState}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('/lists/TEPP1')
        .then((response) => {
            commit('setTypesEpp', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener epps.
 */
export async function fetchEpps({state, commit}, company_id) {

    commit('dashboard/load', true, {root: true});
    await $http_wor.get('epps/' + company_id, {params: {paginate: 0}})
        .then(async (response) => {
            commit('setEpps', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Cargos.
 */
export async function fetchWorkerPositions({state, commit}, {id, company_id, filter}) {

    const data = state.params;

    data.wor_worker_id = id;


    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker-positions/' + company_id, {params: {wor_worker_id: id, filter}})
        .then(async (response) => {
            commit('setWorkerPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}


export async function fetchPositionEpps({state, commit}, {wor_position_id, company_id}) {
    commit('dashboard/load', true, {root: true});

    await $http_wor.get('position-epps/' + company_id, {params: {wor_position_id}})
        .then(async (response) => {
            commit('setPositionEpps', response.data.data);
            commit('setEppsWorkerEpps', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear un cargo del Trabajador.
 */
export async function addWorkerPosition({state, commit, dispatch}, {company_id, id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        const data = state.worker_position;

        data.wor_worker_id = id;

        await $http_wor.post('worker-positions/' + company_id, data)

            .then(async (response) => {

                await dispatch('fetchWorkerPositions', {id, company_id});
                commit('setModalPositionShow', false);

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Actualizar un cargo del Trabajador.
 */
export async function updateWorkerPosition({state, commit, dispatch}, {company_id, id}) {

    return new Promise(async (resolve, reject) => {

        commit('dashboard/load', true, {root: true});

        await $http_wor.put('worker-positions/' + company_id + '/' + id, state.worker_position)

            .then(async (response) => {

                await dispatch('fetchWorkerPositions', {id: state.worker.id, company_id});
                commit('setModalPositionShow', false);

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Obtener un Cargo del Trabajador.
 */
export async function getWorkerPosition({state, commit}, {company_id, id}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker-positions/' + company_id + '/' + id,)
        .then(async (response) => {
            commit('setWorkerPosition', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Capacitaciones del Trabajador.
 */
export async function fetchWorkerTrainings({state, commit,}, {id, company_id, filter}) {

    commit('dashboard/load', true, {root: true});
    await $http_wor.get('worker-trainings/' + company_id, {params: {wor_worker_id: id, filter}})
        .then(async (response) => {
            commit('setWorkerTrainings', response.data.data);
            commit('dashboard/load', false, {root: true});

        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener capacitaciones.
 */
export async function fetchTrainings({state, commit}, company_id) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('trainings/' + company_id)
        .then(async (response) => {
            commit('setTrainings', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear una Capacitación del Trabajador.
 */
export async function addWorkerGroupEpp({state, commit, dispatch}, {company_id, id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        let data = state.worker_group_epp;

        data.wor_worker_id = id;

        await $http_wor.post('worker-group-epps/' + company_id, data)

            .then(async (response) => {

                commit('setShowToModalGroupEpp', false);
                await dispatch('fetchWorkerGroupEpps', {company_id, id});

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Crear una Capacitación del Trabajador.
 */
export async function updateWorkerGroupEpp({state, commit, dispatch}, {company_id, id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        const data = state.worker_group_epp;

        await $http_wor.put('worker-group-epps/' + company_id + '/' + state.worker_group_epp.id, data)

            .then(async (response) => {

                commit('setShowToModalGroupEpp', false);
                await dispatch('fetchWorkerGroupEpps', {company_id, id});

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Obtener Epps del trabajador.
 */
export async function fetchWorkerEpps({state, commit}, {company_id, id}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker-epps/' + company_id, {params: {wor_worker_id: id}})
        .then(async (response) => {
            commit('setWorkerEpps', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear una Capacitación del Trabajador.
 */
export async function addWorkerFitEpp({state, commit, dispatch}, {company_id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        let data = state.worker_epp_fit_test;

        data.wor_worker_epp_id = state.worker_epp.id;

        await $http_wor.post('worker-epp-fit-tests/' + company_id, data)

            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                commit('setWorkerEpp', response.data.data);

                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Crear una Capacitación del Trabajador.
 */
export async function updateWorkerFitEpp({state, commit, dispatch}, {company_id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});
        const data = state.worker_epp_fit_test;

        await $http_wor.put('worker-epp-fit-tests/' + company_id + '/' + state.worker_epp_fit_test.id, data)

            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                commit('setWorkerEpp', response.data.data);

                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Obtener Epps del trabajador.
 */
export async function fetchWorkerGroupEpps({state, commit}, {company_id, id, filter}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker-group-epps/' + company_id, {params: {wor_worker_id: id, filter}})

        .then(async (response) => {
            commit('setWorkerGroupsEpps', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener grupo de epp del trabajador.
 */
export async function getWorkerEpp({state, commit}, {company_id, id}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('worker-epps/' + company_id + '/' + id,)
        .then(async (response) => {
            commit('setWorkerEpp', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener examenes.
 */
export async function fetchExams({state, commit}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('/lists/EXAN1')
        .then((response) => {
            commit('setExams', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}


/**
 * Crear un examen del Trabajador.
 */
export async function addWorkerGroupExam({state, commit, dispatch}, {company_id, id, wor_worker_id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        const data = state.worker_exam;
        data.wor_worker_id = wor_worker_id;

        await $http_wor.post('worker-group-exams/' + company_id, data)

            .then(async (response) => {

                await dispatch('fetchWorkerExams', {wor_worker_id, company_id});
                commit('resetWorkerExam');
                commit('setModalExamShow', false);

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

export async function updateWorkerGroupExam({state, commit, dispatch}, {company_id, id, wor_worker_id}) {
    return new Promise(async (resolve, reject) => {
        commit('dashboard/load', true, {root: true});

        const data = state.worker_exam;

        await $http_wor.put('worker-group-exams/' + company_id + '/' + id, data)

            .then(async (response) => {

                await dispatch('fetchWorkerExams', {wor_worker_id, company_id});
                commit('resetWorkerExam');
                commit('setModalExamShow', false);

                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });

                resolve(response.data.data);

            }).catch(async error => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                reject();
            });
    });

}

/**
 * Obtener Examenes del trabajador.
 */
export async function fetchWorkerExams({state, commit}, {wor_worker_id, company_id, filter}) {

    commit('dashboard/load', true, {root: true});
    await $http_wor.get('worker-group-exams/' + company_id, {params: {wor_worker_id, filter}})
        .then(async (response) => {
            commit('setWorkerGroupExam', response.data.data);
            commit('resetWorkerExam');
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener Examenes del trabajador.
 */
export async function getWorkerExam({state, commit}, {company_id, id}) {

    commit('dashboard/load', true, {root: true});
    await $http_wor.get('worker-group-exams/' + company_id + '/' + id,)
        .then(async (response) => {
            commit('setWorkerExam', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Descargar plantilla
 */
export async function downloadTemplate({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor({
        url: '/workers/download-template',
        method: 'GET',
        responseType: 'blob',
        params: {company_id: state.params.company_id}
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Plantilla trabajadores.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Descargar reporte
 */
export async function downloadReport({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http_wor({
        url: '/workers/generate-report/' + state.params.company_id,
        method: 'GET',
        responseType: 'blob',
        params: state.params
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Reporte trabajadores.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Subir archivo y crear EPPs masivamente.
 */
export async function uploadAndMassiveCreate({commit, state}) {
    let form_data = new FormData();

    for (let key in state.upload) {
        form_data.append(key, state.upload[key]);
    }

    commit('dashboard/load', true, {root: true});

    await $http_wor.post('/workers/massive-creation/' + state.params.company_id, form_data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            let errors = response.data.errors;

            if (errors.length) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: 'Existen inconsistencias en el archivo cargado',
                    showConfirmButton: false,
                    timer: 3000
                });

                errors.unshift({errores: 'errores'});
                let csv = '';
// Loop the array of objects
                for (let row = 0; row < errors.length; row++) {
                    let keysAmount = Object.keys(errors[row]).length;
                    let keysCounter = 0;

                    if (row === 0) {

                        for (let key in errors[row]) {

                            csv += key + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    } else {
                        for (let key in errors[row]) {
                            csv += errors[row][key] + (keysCounter + 1 < keysAmount ? ',' : '\r\n');
                            keysCounter++;
                        }
                    }

                    keysCounter = 0;
                }

                let link = document.createElement('a');
                link.id = 'download-csv';
                link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
                link.setAttribute('download', 'errores.csv');
                document.body.appendChild(link);
                document.querySelector('#download-csv').click();
            } else {
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: true,
                    timer: 2000
                });
            }
        })
        .catch((error) => {

            commit('dashboard/load', false, {root: true});

            console.error(error);

            Notification.error({
                title: 'Error',
                message: 'Error al procesar el archivo',
                type: 'error',
                duration: 5000,
                customClass: 'notification-box',
            });
        });
}



/**
 * Crear trabajador para usuarios con permisos basicos.
 *
 * @param {*} company_id - Id de la empresa.
 * @return {Promise<void>}
 * @author Paul Valencia
 */
export async function saveWorker({ commit, state }, company_id) {
    commit("dashboard/load", true, { root: true });
    try {
        const response = await $http_wor.post(`worker/create/${company_id}`, state.worker);
        this.$vue.$alertSuccess(response.data.message);
        return true;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return false;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}
